import { Injectable } from '@angular/core';
import type { CarCategoryFiltersInterface } from '@zaoblako/shared/modules/cctv/dtos/car-category/car-category-filters.dto';
import type { CarCategoryFindInterface } from '@zaoblako/shared/modules/cctv/dtos/car-category/car-category-find.dto';
import type { CarCategoryPageInterface } from '@zaoblako/shared/modules/cctv/dtos/car-category/car-category-page.dto';
import type { CarCategoryQueryInterface } from '@zaoblako/shared/modules/cctv/dtos/car-category/car-category-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarCategoryService extends BaseService {
  protected baseUrl = '/cctv/base/car-category';

  public findWithPagination(queryParams: CarCategoryQueryInterface): Observable<CarCategoryPageInterface> {
    return this.http.get<CarCategoryPageInterface>(this.baseUrl, { params: this.objectToHttpParams(queryParams) });
  }

  public findFlat(queryParams?: CarCategoryFiltersInterface): Observable<CarCategoryFindInterface[]> {
    return this.http.get<CarCategoryFindInterface[]>(`${this.baseUrl}/flat`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }

  public makeDefault(id: number): Observable<CarCategoryFindInterface> {
    return this.http.post<CarCategoryFindInterface>(`${this.baseUrl}/${id}/default`, {});
  }

  public deleteDefault(id: number): Observable<CarCategoryFindInterface> {
    return this.http.delete<CarCategoryFindInterface>(`${this.baseUrl}/${id}/default`);
  }

  public findDefault(): Observable<CarCategoryFindInterface> {
    return this.http.get<CarCategoryFindInterface>(`${this.baseUrl}/default`);
  }
}
